const leftMenuVisibilityReducer = (state = "show", action) => {
    switch (action.type) {
        case "SET_LEFT_MENU_VISIBILITY":
            return action.payload;
        default:
            return state;
    }
};
export default leftMenuVisibilityReducer;
